const audios = [
  {
    img: process.env.PUBLIC_URL + "/assets/img1.jpg",
    src: process.env.PUBLIC_URL + "/assets/audio1.mp3",
    singer: "Post Malone",
    songName: "Rockstar",
  },
  {
    img: process.env.PUBLIC_URL + "/assets/img2.jpg",
    src: process.env.PUBLIC_URL + "/assets/audio2.mp3",
    singer: "The Weeknd",
    songName: "Starboy",
  },
  {
    img: process.env.PUBLIC_URL + "/assets/img3.jpg",
    src: process.env.PUBLIC_URL + "/assets/audio4.mp3",
    singer: "Drake",
    songName: "One Dance",
  },
  {
    img: process.env.PUBLIC_URL + "/assets/img4.jpg",
    src: process.env.PUBLIC_URL + "/assets/audio3.mp3",
    singer: "Randall",
    songName: "Wahran",
  },
];

export default audios;
